import { render, staticRenderFns } from "./onAndOf.vue?vue&type=template&id=04165c3c&scoped=true&"
import script from "./onAndOf.vue?vue&type=script&lang=js&"
export * from "./onAndOf.vue?vue&type=script&lang=js&"
import style0 from "./onAndOf.vue?vue&type=style&index=0&id=04165c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04165c3c",
  null
  
)

export default component.exports